import React, { useState, useEffect, useRef } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { setActiveBucketName, clearActiveBucketName } from "../../../../../store/slices/Sidebar/ProcessGuideSlice";
import "react-datepicker/dist/react-datepicker.css";
import { fetchAllProjects } from "../../../../../store/slices/projectsSlice";
import ProjectCompletedSales from "../ProjectCompleted/ProjectCompletedSales";
import ProjectOngoingSales from "../ProjectOngoing/ProjectOngoingSales";
import ProjectAssignSales from "../ProjectAssignSales/ProjectAssignSales";
// import ProjectApprovedSales from "../ProjectApproved/ProjectApprovedSales";
import ResponseReceived from "../ResponseReceived/ResponseReceived";
import SalesPresalesOperations from "../ProjectRequest/SalesPresalesOperations";
import {
  fetchHardwareDescriptions,
  fetchHardwareProjectTracking,
} from "../../../../../store/slices/hardwareDescriptionSlice";
import {
  fetchDescriptionTasks,
  fetchDescriptionTasksProjectTracking,
} from "../../../../../store/slices/DescriptionTask";
import {
  fetchWorkEntries,
  fetchWorkEntriesProjectTracking,
} from "../../../../../store/slices/workentriesSlice";
import { fetchEmployees } from "../../../../../store/slices/employeeSlice";
import ApprovedSales from "../ProjectApproved/ApprovedSales";
import MyTraining from "../../../../MyTraining/MyTraining";
import { fetchLeads } from "../../../../../store/slices/leadsSlice";
import UtilizationReport from "../../../OperationFeatures/UtilizationReport";
import TaskInHand from "../../../OperationFeatures/TaskInHand";
import { hasViewOrFullAccess, getFeatureAccessLevel } from "../../../../../utils/featureAccessUtils";

const SalesProjects = ({ wrapperClasses }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { leads } = useSelector((state) => state.leads);
  const { projects } = useSelector((state) => state.projects);
  const { employees } = useSelector((state) => state.employees);
  const { profiles } = useSelector((state) => state.companyProfile);
  const { session } = useSelector((state) => state.session);

  const { entries } = useSelector((state) => state.workentries);
  const { tasks } = useSelector((state) => state.descriptionTasks);
  const { items } = useSelector((state) => state.hardwareDescription);
  const [mergedapprovedData, setmergedapprovedData] = useState([])

  const { projectTrackingWorkEntries } = useSelector(
    (state) => state.workentries
  );
  const { hardwareProjectTracking } = useSelector(
    (state) => state.hardwareDescription
  );
  const { descriptionProjectTracking } = useSelector(
    (state) => state.descriptionTasks
  );

  const selectedTabState = useSelector(
    (state) => state.operationState.selectedTabState
  );
  console.log("selectedTaskId selectedTabState", selectedTabState)

  useEffect(() => {
    if (selectedTabState) {
      // setSelectedTab(selectedTabState)
      setShowongoing(true)
      setShowaproved(false);
      setShowRR(false);
      setShowassign(false);
      setShowcomplete(false);
      setShowOutstanding(false);
    }
  }, [selectedTabState])

  const [ongoingEntries, setongoingEntries] = useState([]);
  const [ongoingHardwareParts, setongoingHardwareParts] = useState([]);

  const [showOutstanding, setShowOutstanding] = useState(false);
  const [showRR, setShowRR] = useState(false);
  const [showaproved, setShowaproved] = useState(false);
  const [showassign, setShowassign] = useState(false);
  const [showongoing, setShowongoing] = useState(false);
  const [showcomplete, setShowcomplete] = useState(false);
  const [hoveredRequestBucket, setHoveredRequestBucket] = useState("");
  const [currentEmployee, setcurrentEmployee] = useState();
  const subscriptionPackage = profiles?.[0]?.subscriptionpackage || "";
  const isCrmPackage = subscriptionPackage?.toUpperCase() === "CRM";
  const isErpPackage = subscriptionPackage?.toUpperCase() === "ERP";
  const email = localStorage.getItem("email")

  console.log("currentEmployee", window.innerWidth)

  useEffect(() => {
    const employee = employees.find((emp) => emp.EmpEmail === email);
    console.log("fsgsdg", employee)
    setcurrentEmployee(employee)
  }, [email, employees]);

  // When all buckets are closed, reset Process Guide text back to default
  useEffect(() => {
    if (
      !showOutstanding &&
      !showRR &&
      !showaproved &&
      !showassign &&
      !showongoing &&
      !showcomplete
    ) {
      dispatch(clearActiveBucketName());
    }
  }, [showOutstanding, showRR, showaproved, showassign, showongoing, showcomplete, dispatch]);


  useEffect(() => {
    dispatch(fetchWorkEntries());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchDescriptionTasks());
    dispatch(fetchEmployees())
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchDescriptionTasksProjectTracking());
    dispatch(fetchHardwareProjectTracking());
  }, [dispatch]);


  const handlerefresh = () => {
    dispatch(fetchAllProjects());
    dispatch(fetchLeads());
  };

  const handleprojectRequest = () => {
    setShowOutstanding(!showOutstanding);
    setShowRR(false);
    setShowaproved(false);
    setShowassign(false);
    setShowongoing(false);
    setShowcomplete(false);
    // setSelectedTab("projectRequestOutstanding");
    dispatch(fetchAllProjects());
    handleTabClick("projectRequestOutstanding")

  };
  const handleProjectReceivedList = () => {
    setShowRR(!showRR);
    setShowaproved(false);
    setShowassign(false);
    setShowongoing(false);
    setShowcomplete(false);
    setShowOutstanding(false);
    // setSelectedTab("projectReceived");
    dispatch(fetchAllProjects());
    handleTabClick("projectReceived");
  };

  const handleProjectApproved = () => {
    setShowaproved(!showaproved);
    setShowRR(false);
    setShowassign(false);
    setShowongoing(false);
    setShowcomplete(false);
    setShowOutstanding(false);
    // setSelectedTab("projectApproved");
    dispatch(fetchAllProjects());
    handleTabClick("projectApproved")

  };

  const handleProjectAssignList = () => {
    setShowassign(!showassign);
    setShowaproved(false);
    setShowRR(false);
    setShowongoing(false);
    setShowcomplete(false);
    setShowOutstanding(false);
    // setSelectedTab("projectAssign");
    dispatch(fetchAllProjects());
    handleTabClick("projectAssign")

  };

  const handleprojectOngoing = () => {
    setShowongoing(!showongoing);
    setShowaproved(false);
    setShowRR(false);
    setShowassign(false);
    setShowcomplete(false);
    setShowOutstanding(false);
    // setSelectedTab("projectOngoing");
    dispatch(fetchAllProjects());
    handleTabClick("projectOngoing")

  };
  const handleprojectCompleted = () => {
    setShowcomplete(!showcomplete);
    setShowaproved(false);
    setShowRR(false);
    setShowongoing(false);
    setShowassign(false);
    setShowOutstanding(false);
    // setSelectedTab("projectCompleted");
    dispatch(fetchAllProjects());
    handleTabClick("projectCompleted")


  };

  const showUpgradePopupForErp = () => {
    enqueueSnackbar("Upgrade your package to ERP", { variant: "success" });
  };

  const handleRestrictedBucketClick = (handler, bucketName, allowInCrm = false) => {
    if (isCrmPackage && !allowInCrm) {
      showUpgradePopupForErp();
      return;
    }
    handler();
    dispatch(setActiveBucketName(bucketName));
  };

  const [groupedProjects, setGroupedProjects] = useState([]);

  useEffect(() => {
    if (projects?.length > 0 && employees?.length > 0) {
      const isTruthyRejectedFlag = (value) => {
        if (typeof value === "string") {
          return value.toLowerCase() === "true";
        }
        return Boolean(value);
      };

      const filteredProjects = projects.filter((proj) => proj?.isProjecttracking === false)

      // Group by quotationId when present (so same ProjectName+Client+Group but different quotationId = separate rows), else composite key
      const groupedByProjectName = filteredProjects.reduce((acc, project) => {
        const key = project.quotationId ? String(project.quotationId).trim() : `${project.ProjectName || ''}||${project.ClientName || ''}||${project.AssignedGroup || ''}`.toLowerCase().trim();
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(project);
        return acc;
      }, {});
      // REFACTORED: Extract ProjectName from composite key for display
      // UNDO: Change back to using projectName directly if reverting
      const summarizedData = Object.entries(groupedByProjectName).map(
        ([compositeKey, projectGroup]) => {
          // Extract ProjectName from first project in group (all should have same name)
          const projectName = projectGroup[0]?.ProjectName || compositeKey.split('||')[0];
          const allAssignedManagerEmails = projectGroup.flatMap(
            (p) => p.AssignedManagerEmail || []
          );

          // CASE 1: PrimaryResources is "1"
          const flaggedProject = projectGroup.find(
            (p) =>
              p.PrimaryResources === "1" || Number(p.PrimaryResources) === 1
          );

          // CASE 2: PrimaryResources is email or array of emails
          const primaryResourceEmails = flaggedProject
            ? flaggedProject.AssignedManagerEmail || []
            : projectGroup.flatMap((p) => {
              if (
                typeof p.PrimaryResources === "string" &&
                p.PrimaryResources.includes("@")
              ) {
                return [p.PrimaryResources];
              } else if (Array.isArray(p.PrimaryResources)) {
                return p.PrimaryResources.filter((email) =>
                  email.includes("@")
                );
              }
              return [];
            });

          const getNameFromEmail = (email) => {
            const person = employees.find((emp) => emp.EmpEmail === email);
            return person
              ? `${person.EmpFirstName} ${person.EmpLastName}`
              : email;
          };

          const AssignedManager = [...new Set(allAssignedManagerEmails)].map(
            getNameFromEmail
          );

          const PrimaryResource = [...new Set(primaryResourceEmails)].map(
            getNameFromEmail
          );

          // ✅ Build detailed ProjectManagerAction array with salespersonstatus
          const ProjectManagerAction = projectGroup.map((p) => {
            const managerEmail = (p.AssignedManagerEmail || [])[0]; // Assuming 1 manager per project entry
            const managerName = getNameFromEmail(managerEmail);

            // Get salespersonstatus from Assignedperson if available
            let salesStatus = " ";
            if (p.Assignedperson && p.Assignedperson.length > 0) {
              const statuses = p.Assignedperson.map(
                (person) => person.salespersonstatus
              );
              if (statuses.includes("response received")) {
                salesStatus = "response received";
              } else if (statuses.includes("project assigned")) {
                salesStatus = "project assigned";
              }
            }

            const AssignedPerson = p.Assignedperson ? p.Assignedperson.map(person => ({
              name: person.name,
              email: person.email,
              salespersonstatus: person.salespersonstatus || " ",
              salespersonaction: person.salespersonaction || " ",
              manageraction: person.manageraction || " ",
              operationaction: person.operationaction || " ",
              taskStatus: person.taskStatus || " ",
              OpDueDate: person.OpDueDate || null,
              _id: person._id,
              isProjectoutstanding: person.isProjectoutstanding || false
            })) : [];

            return {
              ProjectId: p._id,
              Manager: managerName,
              ManagerEmail: managerEmail,
              ManagerAction: p.ProjectManagerAction || " ",
              ResourceType: p.ResourceType || " ",
              TypeService: p.TypeService,
              SalesPersonStatus: salesStatus,
              AssignedPerson: AssignedPerson,
              ProjectManagerActionSummary: p.ProjectManagerAction,
              isRejectedProject:
                isTruthyRejectedFlag(p?.isRejectedProject) ||
                isTruthyRejectedFlag(p?.isRejectedproject)

            };
          });

          // const ProjectManagerActionSummary =
          //   projectGroup.find((p) => p.ProjectManagerAction)?.ProjectManagerAction ||
          //   "";
          return {
            ProjectName: projectName,
            ClientName: projectGroup[0]?.ClientName || '',
            AssignedGroup: projectGroup[0]?.AssignedGroup || '',
            quotationId: projectGroup[0]?.quotationId || null,
            DateDue: projectGroup[0].ProjectDueDate,
            AssignedManager,
            PrimaryResource,
            ProjectManagerAction,
            isRejectedProject: projectGroup.some(
              (p) =>
                isTruthyRejectedFlag(p?.isRejectedProject) ||
                isTruthyRejectedFlag(p?.isRejectedproject)
            ),
          };
        }
      );
      setGroupedProjects(summarizedData);
    }
  }, [projects, employees]);
  const [requestedprojectsNew, SetrequestedprojectsNew] = useState([]);
  const [requestedprojects, Setrequestedprojects] = useState([]);
  const [projectsReceived, setProjectsReceived] = useState([]);
  const [projectsApprovedSales, setProjectsApprovedSales] = useState([]);
  const [salesAssignedGroupProject, setSalesAssignedGroupProject] = useState(
    []
  );
  const [ongoingSalesProject, setOngoingSalesProject] = useState([]);
  const [salesCompletedGroupProject, setSalesCompletedGroupProject] = useState(
    []
  );
  const [unreadleadcount, setunreadleadcount] = useState([]);
  const [unreadleadcountRR, setunreadleadcountRR] = useState([]);
  const [unreadleadcountapproved, setunreadleadcountapproved] = useState([]);
  const [unreadleadcountassign, setunreadleadcountassign] = useState([]);
  const [unreadleadcountongoing, setunreadleadcountongoing] = useState([]);
  const [unreadleadcountcomplete, setunreadleadcountcomplete] = useState([]);


  console.log("gdfghd", requestedprojectsNew)
  useEffect(() => {
    const unreadProjects = requestedprojectsNew.filter(project => project.isRead === false);
    setunreadleadcount(unreadProjects)
  }, [requestedprojectsNew]);

  useEffect(() => {
    const unreadProjects = projectsReceived.filter(project => project.isRead === false);
    setunreadleadcountRR(unreadProjects)
  }, [projectsReceived]);

  useEffect(() => {
    const unreadProjects = mergedapprovedData.filter(project => project.isRead === false);
    setunreadleadcountapproved(unreadProjects)
  }, [mergedapprovedData]);

  useEffect(() => {
    const unreadProjects = salesAssignedGroupProject.filter(project => project.isRead === false);
    setunreadleadcountassign(unreadProjects)
  }, [salesAssignedGroupProject]);

  useEffect(() => {
    const unreadProjects = ongoingSalesProject.filter(project => project.isRead === false);
    setunreadleadcountongoing(unreadProjects)
  }, [ongoingSalesProject]);
  useEffect(() => {
    const unreadProjects = salesCompletedGroupProject.filter(project => project.isRead === false);
    setunreadleadcountcomplete(unreadProjects)
  }, [salesCompletedGroupProject]);

  // Match by quotationId when available so same Group/Client/ProjectName but different quotationId = separate rows
  useEffect(() => {
    const filteredleads = leads.filter((project) => project.SalesPersonStatus === "project requested")
      .filter((project) => {
        const matchingGroupedProjects = groupedProjects?.filter((gp) => {
          if (project.quotationId && gp.quotationId) return gp.quotationId === project.quotationId;
          const projectKey = `${project.ProjectName || ''}||${project.ClientName || ''}||${project.AssignedGroup || ''}`.toLowerCase().trim();
          const gpKey = `${gp.ProjectName || ''}||${gp.ClientName || project.ClientName || ''}||${gp.AssignedGroup || project.AssignedGroup || ''}`.toLowerCase().trim();
          return gpKey === projectKey;
        });
        if (!matchingGroupedProjects || matchingGroupedProjects.length === 0) {
          return true; // keep if no grouped project exists
        }
        // Check ALL ProjectManagerActions across ALL matching grouped projects
        const allResponded = matchingGroupedProjects.every((gp) => {
          // For each grouped project, check ALL its ProjectManagerAction entries
          return gp.ProjectManagerAction?.every((action) => {
            // If no assigned persons, this action hasn't been responded to
            if (!action.AssignedPerson || action.AssignedPerson.length === 0) {
              return false; // Not all responded (no one to respond)
            }
            // For each manager action, check ALL assigned persons
            return action.AssignedPerson?.every(
              (person) => (person?.salespersonstatus?.toLowerCase() === "response received" ||
                person?.salespersonstatus?.toLowerCase() === "project approved" ||
                person?.salespersonstatus?.toLowerCase() === "project assigned" ||
                person?.salespersonstatus?.toLowerCase() === "project ongoing" ||
                person?.salespersonstatus?.toLowerCase() === "project complete" ||
                person?.salespersonstatus?.toLowerCase() === "project assigned to other") && person.isProjectoutstanding === false
            );
          });
        });

        // Exclude if everyone responded in ALL managers and ALL assigned persons
        return !allResponded;
      })
      .sort((a, b) => b._id.localeCompare(a._id));
    Setrequestedprojects(filteredleads);
  }, [leads, groupedProjects]);

  // useEffect(() => {
  //   const groupedByProjectName = projects.reduce((acc, project) => {
  //     const projectName = project.ProjectName?.trim() || 'Unnamed Project';

  //     if (!acc[projectName]) {
  //       acc[projectName] = [];
  //     }

  //     acc[projectName].push(project);
  //     return acc;
  //   }, {});
  //   const requestedprojectsWithGroupedData = requestedprojects.map(requestedProject => {
  //     const projectName = requestedProject.ProjectName?.trim();

  //     if (projectName && groupedByProjectName[projectName]) {
  //       return {
  //         ...requestedProject,
  //         groupedProjects: groupedByProjectName[projectName] // Add the grouped projects
  //       };
  //     }

  //     return {
  //       ...requestedProject,
  //       groupedProjects: [] // Add empty array if no matching projects found
  //     };
  //   });
  // }, [requestedprojects, projects]);

  // Group by quotationId when present so same name but different quotationId = separate entries
  useEffect(() => {
    const groupedByProjectName = projects.reduce((acc, project) => {
      const key = project.quotationId ? String(project.quotationId).trim() : `${project.ProjectName?.trim() || 'Unnamed Project'}||${project.ClientName || ''}||${project.AssignedGroup || ''}`.toLowerCase().trim();
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(project);
      return acc;
    }, {});

    const requestedprojectsWithGroupedData = requestedprojects.map(requestedProject => {
      const projectKey = requestedProject.quotationId ? String(requestedProject.quotationId).trim() : `${requestedProject.ProjectName?.trim() || ''}||${requestedProject.ClientName || ''}||${requestedProject.AssignedGroup || ''}`.toLowerCase().trim();

      if (projectKey && groupedByProjectName[projectKey]) {
        return {
          ...requestedProject,
          groupedProjects: groupedByProjectName[projectKey]
        };
      }

      return {
        ...requestedProject,
        groupedProjects: []
      };
    });

    // Filter out projects that match the exclusion conditions
    const filteredRequestedProjects = requestedprojectsWithGroupedData.filter(requestedProject => {
      const status = requestedProject.Status;
      const isWonOrWonRecurring = status === "Won" || status === "Won Recurring" || status === "won" || status === "won recurring";
      const hasGroupedProjects = requestedProject.groupedProjects && requestedProject.groupedProjects.length > 0;

      // If not Won or won recurring, keep the project
      if (!isWonOrWonRecurring) {
        return true;
      }

      // Condition 1: Status is Won/won recurring but no groupedProjects - EXCLUDE
      if (isWonOrWonRecurring && !hasGroupedProjects) {
        return false;
      }

      // Condition 2: Status is Won/won recurring AND all assigned persons in all grouped projects have manageraction: "complete"
      if (isWonOrWonRecurring && hasGroupedProjects) {
        const allPersonsComplete = requestedProject.groupedProjects.every(groupedProject => {
          // Check if the project has assigned persons
          if (!groupedProject.Assignedperson || groupedProject.Assignedperson.length === 0) {
            return true; // No assigned persons means condition is technically met
          }

          // Check if all assigned persons have manageraction: "complete"
          return groupedProject.Assignedperson.every(person =>
            person.manageraction === "complete" || person.salespersonstatus === "project approved" || person.salespersonstatus === "project ongoing" || person.salespersonstatus === "project not-assigned"
          );
        });

        // If all persons in all projects are complete, EXCLUDE this project salespersonstatus:
        if (allPersonsComplete) {
          return false;
        }
      }

      // Keep the project if it doesn't match any exclusion condition
      return true;
    });


    const data = filteredRequestedProjects.sort((a, b) => a.isRead - b.isRead);
    console.log("HFjfg", data)
    // Use filteredRequestedProjects for your further logic
    SetrequestedprojectsNew(data)
  }, [requestedprojects, projects]);

  useEffect(() => {
    let hasChanges = false;

    const updatedProjects = requestedprojects.map((project) => {
      if (!project.DateDue && project.LeadDate) {
        hasChanges = true;
        return {
          ...project,
          DateDue: new Date(
            new Date(project.LeadDate).getTime() + 7 * 24 * 60 * 60 * 1000
          ),
        };
      }
      return project;
    });

    if (hasChanges) {
      Setrequestedprojects(updatedProjects);
    }
  }, [requestedprojects]);


  useEffect(() => {
    if (projects?.length) {
      // Group by quotationId when present so same ProjectName but different quotationId = separate rows (Response Received)
      const projectKey = (p) => p.quotationId ? String(p.quotationId).trim() : `${p.ProjectName || ''}||${p.ClientName || ''}||${p.AssignedGroup || ''}`.toLowerCase().trim();
      const projectsGroupedByName = projects.reduce((acc, project) => {
        const key = projectKey(project);
        const existingGroup = acc.find((g) => (g.quotationId != null && project.quotationId != null ? String(g.quotationId) === String(project.quotationId) : g._key === key));
        if (existingGroup) {
          existingGroup.Projects.push(project);
        } else {
          acc.push({
            _key: key,
            quotationId: project.quotationId || null,
            ProjectName: project.ProjectName,
            ClientName: project.ClientName,
            AssignedGroup: project.AssignedGroup,
            groupid: project.groupid,
            Projects: [project],
          });
        }
        return acc;
      }, []);

      const qualifiedGroups = projectsGroupedByName.filter((group) => {
        return group.Projects.every((project) => {
          if (!project?.Assignedperson?.length) return false;
          return project.Assignedperson.every(
            (person) => person.salespersonstatus === "response received" &&
              person.isProjectoutstanding === false
          );
        });
      });

      const groupedProjects = qualifiedGroups.map((group) => {
        const matchByQuotation = group.Projects[0]?.quotationId != null;
        const matchingLead = leads.find(lead => {
          if (matchByQuotation && lead.quotationId != null) return String(lead.quotationId) === String(group.Projects[0].quotationId);
          const leadKey = `${lead.ProjectName || ''}||${lead.ClientName || ''}||${lead.AssignedGroup || ''}`.toLowerCase().trim();
          const groupKey = `${group.ProjectName || ''}||${group.ClientName || ''}||${group.AssignedGroup || ''}`.toLowerCase().trim();
          return leadKey === groupKey;
        });

        return {
          quotationId: group.Projects[0]?.quotationId || null,
          isRead: matchingLead?.isRead || false,
          AssignedGroup: group.Projects[0].AssignedGroup,
          groupid: group.Projects[0]?.groupid,
          ProjectName: group.ProjectName,
          ClientName: group.ClientName || group.Projects[0]?.ClientName || '',
          DateRequested: group.Projects[0].DateRequested,
          ProjectDueDate: group.Projects[0].ProjectDueDate,
          Projects: group.Projects,
        };
      });

      setProjectsReceived(groupedProjects);
    }
  }, [projects, leads]);


  useEffect(() => {
    if (projects?.length) {
      // const projectsWithQualifiedPersons = projects.filter((project) =>
      //   project?.Assignedperson?.some(
      //     (person) => person.salespersonstatus === "project approved"
      //   )
      // );
      // const groupedProjects = projects.reduce(
      //   (acc, project) => {
      //     const existingGroup = acc.find(
      //       (group) => group.ProjectName === project.ProjectName
      //     );
      //     if (existingGroup) {
      //       // ✅ Insert validation here
      //       const sameTypeExists = existingGroup.Projects.filter(
      //         (p) => p.TypeService === project.TypeService
      //       );

      //       if (sameTypeExists.length > 0) {
      //         // Check if any existing project with same TypeService has isProjecttracking: true
      //         const hasTrackingTrue = sameTypeExists.some(p => p.isProjecttracking === true);

      //         // Check if the current project has isProjecttracking: true
      //         const currentProjectIsTracking = project.isProjecttracking === true;

      //         if (hasTrackingTrue && currentProjectIsTracking) {
      //           // If both existing and current project have tracking true, keep both
      //           // No need to filter, just push the current project
      //           existingGroup.Projects.push(project);
      //         } else if (hasTrackingTrue && !currentProjectIsTracking) {
      //           // If existing has tracking true but current is false, skip adding current project
      //           // Do nothing
      //         } else if (!hasTrackingTrue && currentProjectIsTracking) {
      //           // If existing has tracking false but current is true, replace all with current
      //           existingGroup.Projects = existingGroup.Projects.filter(
      //             (p) => p.TypeService !== project.TypeService
      //           );
      //           existingGroup.Projects.push(project);
      //         } else {
      //           // Both have tracking false, keep the existing ones (or you can choose to replace)
      //           // For now, let's keep the existing ones and skip adding current
      //           // Do nothing
      //         }
      //       } else {
      //         // No duplicate TypeService yet → just push
      //         existingGroup.Projects.push(project);
      //       }
      //     } else {
      //       acc.push({
      //         AssignedGroup: project.AssignedGroup,
      //         ProjectName: project.ProjectName,
      //         DateRequested: project.DateRequested,
      //         ProjectDueDate: project.ProjectDueDate,
      //         Projects: [project],
      //       });
      //     }

      //     return acc;
      //   },
      //   []
      // );


      // REFACTORED: Group by quotationId when present so (Group, ClientName, ProjectName) with different quotationIds = separate rows
      const projectKey = (p) => p.quotationId != null && String(p.quotationId).trim() !== ""
        ? String(p.quotationId).trim()
        : `${(p.ProjectName || '')}||${(p.ClientName || '')}||${(p.AssignedGroup || '')}`.toLowerCase().trim();
      const groupedProjects = projects.reduce(
        (acc, project) => {
          const key = projectKey(project);
          const existingGroup = acc.find((group) => {
            if (project.quotationId != null && String(project.quotationId).trim() !== "" && group.quotationId != null) {
              return String(group.quotationId) === String(project.quotationId);
            }
            const groupKey = group.quotationId == null ? `${(group.ProjectName || '')}||${(project.ClientName || '')}||${(group.AssignedGroup || project.AssignedGroup || '')}`.toLowerCase().trim() : null;
            return groupKey !== null && groupKey === key;
          });

          if (existingGroup) {
            const sameTypeAndManagerExists = existingGroup.Projects.filter(
              (p) => p.TypeService === project.TypeService &&
                JSON.stringify(p.AssignedManagerEmail) === JSON.stringify(project.AssignedManagerEmail)
            );

            if (sameTypeAndManagerExists.length > 0) {
              const hasTrackingTrue = sameTypeAndManagerExists.some(p => p.isProjecttracking === true);
              const currentProjectIsTracking = project.isProjecttracking === true;

              if (hasTrackingTrue && currentProjectIsTracking) {
                existingGroup.Projects.push(project);
              } else if (hasTrackingTrue && !currentProjectIsTracking) {
                // skip
              } else if (!hasTrackingTrue && currentProjectIsTracking) {
                existingGroup.Projects = existingGroup.Projects.filter(
                  (p) => !(p.TypeService === project.TypeService &&
                    JSON.stringify(p.AssignedManagerEmail) === JSON.stringify(project.AssignedManagerEmail))
                );
                existingGroup.Projects.push(project);
              } else {
                existingGroup.Projects.push(project);
              }
            } else {
              existingGroup.Projects.push(project);
            }
          } else {
            acc.push({
              quotationId: project.quotationId ?? null,
              AssignedGroup: project.AssignedGroup,
              ProjectName: project.ProjectName,
              ClientName: project.ClientName,
              DateRequested: project.DateRequested,
              ProjectDueDate: project.ProjectDueDate,
              Projects: [project],
            });
          }

          return acc;
        },
        []
      );

      // const groupedProjects = projects.reduce(
      //   (acc, project) => {
      //     const existingGroup = acc.find(
      //       (group) => group.ProjectName === project.ProjectName
      //     );
      //     if (existingGroup) {
      //       // Find existing projects with same TypeService
      //       const sameTypeExists = existingGroup.Projects.filter(
      //         (p) => p.TypeService === project.TypeService
      //       );
      //       if (sameTypeExists.length > 0) {
      //         // Check if any existing project with same TypeService has isProjecttracking: true
      //         const hasTrackingTrue = sameTypeExists.some(p => p.isProjecttracking === true);

      //         // Check if the current project has isProjecttracking: true
      //         const currentProjectIsTracking = project.isProjecttracking === true;

      //         if (hasTrackingTrue && currentProjectIsTracking) {
      //           // If both existing and current project have tracking true, keep both
      //           existingGroup.Projects.push(project);
      //         } else if (hasTrackingTrue && !currentProjectIsTracking) {
      //           // If existing has tracking true but current is false, skip adding current project
      //           // Do nothing
      //           existingGroup.Projects.push(project);
      //         } else if (!hasTrackingTrue && currentProjectIsTracking) {
      //           // If existing has tracking false but current is true, replace all with current
      //           existingGroup.Projects = existingGroup.Projects.filter(
      //             (p) => p.TypeService !== project.TypeService
      //           );
      //           existingGroup.Projects.push(project);
      //         } else {
      //           // Both have tracking false - ADD ALL PROJECTS (removed the "do nothing")
      //           existingGroup.Projects.push(project);
      //         }
      //       } else {
      //         // No duplicate TypeService yet → just push
      //         existingGroup.Projects.push(project);
      //       }
      //     } else {
      //       acc.push({
      //         AssignedGroup: project.AssignedGroup,
      //         ProjectName: project.ProjectName,
      //         DateRequested: project.DateRequested,
      //         ProjectDueDate: project.ProjectDueDate,
      //         Projects: [project],
      //       });
      //     }

      //     return acc;
      //   },
      //   []
      // );
      const excludedStatuses = ["Won", "won", "Won Recurring", "won recurring"];

      const filteredLeads = leads.filter(
        (lead) => excludedStatuses.includes(lead.Status)
      );

      // Sort leads by createdAt date (newest first)
      const sortedLeads = filteredLeads.sort((a, b) => {
        const dateA = new Date(a.createdAt || a.LeadDate);
        const dateB = new Date(b.createdAt || b.LeadDate);
        return dateB - dateA; // Descending order (newest first)
      });

      // Match leads to groups by quotationId when both have it (differentiate same ProjectName/Group/Client); else by ProjectName + ClientName + AssignedGroup
      const mergedArray = sortedLeads.map(lead => {
        const leadQuotationId = lead.quotationId != null ? String(lead.quotationId).trim() : null;
        const matchingProjects = groupedProjects.filter((projectGroup) => {
          const groupQuotationId = projectGroup.quotationId != null ? String(projectGroup.quotationId).trim() : null;
          if (leadQuotationId && groupQuotationId) {
            return leadQuotationId === groupQuotationId;
          }
          const groupProjectName = (projectGroup.ProjectName || "").toLowerCase().trim();
          const leadProjectName = (lead.ProjectName || "").toLowerCase().trim();
          const groupClient = (projectGroup.ClientName || "").toLowerCase().trim();
          const leadClient = (lead.ClientName || "").toLowerCase().trim();
          const groupAssigned = (projectGroup.AssignedGroup || "").toLowerCase().trim();
          const leadAssigned = (lead.AssignedGroup || "").toLowerCase().trim();
          return groupProjectName === leadProjectName && groupClient === leadClient && groupAssigned === leadAssigned;
        });

        const allProjects = matchingProjects.flatMap(mp => mp.Projects || []);

        const filteredMatchingProjects = matchingProjects.map(mp => {
          return {
            ...mp,
            Projects: (mp.Projects || []).filter(proj => {
              const hasTrackingChild = allProjects.some(child =>
                child.oldprojectid === proj._id &&
                child.isProjecttracking === true &&
                child.TypeService === proj.TypeService
              );
              return !(proj.isProjecttracking === false && hasTrackingChild);
            })
          };
        });

        let projectsToAttach = filteredMatchingProjects.flatMap(mp => mp.Projects || []);
        if (leadQuotationId) {
          projectsToAttach = projectsToAttach.filter(
            (p) => p.quotationId != null && String(p.quotationId).trim() === leadQuotationId
          );
        }

        return {
          ...lead,
          projects: projectsToAttach
        };
      });

      // Do not show in Project Approved tab if any forwarded project has Assignedperson with salespersonstatus "project assigned" | "project ongoing" | "project complete"
      const excludedprojectStatuses = ["project assigned", "project ongoing", "project complete"];
      const filteredForApprovedTab = mergedArray.filter((item) => {
        if (!item.projects || item.projects.length === 0) return true;
        const hasExcludedStatus = item.projects.some((proj) =>
          proj.Assignedperson?.some((p) =>
            p?.salespersonstatus && excludedprojectStatuses.includes(String(p.salespersonstatus).toLowerCase().trim())
          )
        );
        return !hasExcludedStatus;
      });

      // Include projects from managermainproject that have salespersonstatus "project approved" but are NOT in lead data
      const managerOnlyApprovedRows = groupedProjects
        .filter((projectGroup) => {
          const groupQuotationId = projectGroup.quotationId != null ? String(projectGroup.quotationId).trim() : null;
          const hasMatchingLead = sortedLeads.some((lead) => {
            const leadQuotationId = lead.quotationId != null ? String(lead.quotationId).trim() : null;
            if (groupQuotationId && leadQuotationId) return groupQuotationId === leadQuotationId;
            const groupProjectName = (projectGroup.ProjectName || "").toLowerCase().trim();
            const leadProjectName = (lead.ProjectName || "").toLowerCase().trim();
            const groupClient = (projectGroup.ClientName || "").toLowerCase().trim();
            const leadClient = (lead.ClientName || "").toLowerCase().trim();
            const groupAssigned = (projectGroup.AssignedGroup || "").toLowerCase().trim();
            const leadAssigned = (lead.AssignedGroup || "").toLowerCase().trim();
            return groupProjectName === leadProjectName && groupClient === leadClient && groupAssigned === leadAssigned;
          });
          return !hasMatchingLead;
        })
        .map((projectGroup) => {
          const projectsWithApproved = (projectGroup.Projects || []).filter((proj) =>
            proj.Assignedperson?.some((p) => String(p?.salespersonstatus || "").toLowerCase().trim() === "project approved")
          );
          if (projectsWithApproved.length === 0) return null;
          const firstProj = projectsWithApproved[0];
          return {
            AssignedGroup: projectGroup.AssignedGroup || firstProj?.AssignedGroup,
            ProjectName: projectGroup.ProjectName || firstProj?.ProjectName,
            ClientName: projectGroup.ClientName || firstProj?.ClientName || "",
            quotationId: projectGroup.quotationId ?? firstProj?.quotationId ?? null,
            DateRequested: projectGroup.DateRequested || firstProj?.DateRequested,
            ProjectDueDate: projectGroup.ProjectDueDate || firstProj?.ProjectDueDate,
            LeadDate: projectGroup.DateRequested || firstProj?.DateRequested,
            projects: projectsWithApproved,
            TypeService: projectsWithApproved.map((p) => p.TypeService).filter(Boolean),
            isRead: false,
          };
        })
        .filter(Boolean);

      setProjectsApprovedSales([...filteredForApprovedTab, ...managerOnlyApprovedRows]);
    }
  }, [projects,
    salesAssignedGroupProject,
    ongoingSalesProject,
    salesCompletedGroupProject,
    leads
  ]);

  // useEffect(() => {
  //   const filteredData = projectsApprovedSales.filter(item => {
  //     // If projects array is empty, include the item
  //     if (!item.projects || item.projects.length === 0) {
  //       return true;
  //     }

  //     // If projects array has items, check all assigned persons in all projects
  //     return item.projects.every(project => {
  //       // Check if project has assigned persons
  //       if (!project.Assignedperson || project.Assignedperson.length === 0) {
  //         return false; // No assigned persons, exclude this item
  //       }

  //       // Check if ALL assigned persons have salespersonstatus as "project approved"
  //       return project.Assignedperson.every(person =>
  //         person.salespersonstatus === "project approved"
  //       );
  //     });
  //   });

  //   setmergedapprovedData(filteredData);
  // }, [projectsApprovedSales]);


  // Tab shows all Won leads (differentiate by quotationId): no project = select option, has project = list of managers
  useEffect(() => {
    setmergedapprovedData(projectsApprovedSales);
  }, [projectsApprovedSales]);

  // REFACTORED: Group by composite key for "project assigned" status
  // UNDO: Change back to grouping by ProjectName only if reverting
  useEffect(() => {
    if (projects?.length) {
      const projectKey = (p) =>
        p.quotationId != null && String(p.quotationId).trim() !== ""
          ? String(p.quotationId).trim()
          : `${(p.ProjectName || '')}||${(p.ClientName || '')}||${(p.AssignedGroup || '')}`.toLowerCase().trim();

      const projectsGroupedByName = projects.reduce((acc, project) => {
        const key = projectKey(project);
        const existingGroup = acc.find((g) => {
          const gKey = g.quotationId != null
            ? String(g.quotationId)
            : `${(g.ProjectName || '')}||${(project.ClientName || '')}||${(g.AssignedGroup || project.AssignedGroup || '')}`.toLowerCase().trim();
          return gKey === key;
        });
        if (existingGroup) {
          existingGroup.Projects.push(project);
        } else {
          acc.push({
            quotationId: project.quotationId ?? null,
            ProjectName: project.ProjectName,
            ClientName: project.ClientName,
            AssignedGroup: project.AssignedGroup,
            Projects: [project],
          });
        }
        return acc;
      }, []);

      const qualifiedGroups = projectsGroupedByName
        .map((group) => {
          const validProjects = group.Projects.filter((project) => {
            if (!project?.Assignedperson?.length) return false;
            return project.Assignedperson.every(
              (person) => person.salespersonstatus === "project assigned"
            );
          });

          return {
            ...group,
            Projects: validProjects,
          };
        })
        .filter((group) => group.Projects.length > 0);


      const groupedProjects = qualifiedGroups.map((group) => {
        const matchingLead = leads.find((lead) => {
          if (group.quotationId != null && lead.quotationId != null) {
            return String(lead.quotationId) === String(group.quotationId);
          }
          const leadKey = `${(lead.ProjectName || '')}||${(lead.ClientName || '')}||${(lead.AssignedGroup || '')}`.toLowerCase().trim();
          const groupKey = `${(group.ProjectName || '')}||${(lead.ClientName || '')}||${(group.AssignedGroup || lead.AssignedGroup || '')}`.toLowerCase().trim();
          return leadKey === groupKey;
        });
        return {
          quotationId: group.quotationId ?? null,
          isRead: matchingLead?.isRead || false,
          AssignedGroup: group.Projects[0].AssignedGroup,
          groupid: group.Projects[0]?.groupid,
          ProjectName: group.ProjectName,
          ClientName: group.ClientName || group.Projects[0]?.ClientName || '',
          DateRequested: group.Projects[0].DateRequested,
          ProjectDueDate: group.Projects[0].ProjectDueDate,
          Projects: group.Projects,
        };
      });
      setSalesAssignedGroupProject(groupedProjects);
    }
  }, [projects, leads]);

  useEffect(() => {
    if (projects?.length) {
      const projectsWithQualifiedPersons = projects.filter((project) =>
        project?.Assignedperson?.some(
          (person) => person.salespersonstatus === "project ongoing"
        )
      );

      const projectKey = (p) => p.quotationId ? String(p.quotationId).trim() : `${p.ProjectName || ''}||${p.ClientName || ''}||${p.AssignedGroup || ''}`.toLowerCase().trim();
      const groupedProjects = projectsWithQualifiedPersons.reduce(
        (acc, project) => {
          const key = projectKey(project);
          const existingGroup = acc.find((group) =>
            group.quotationId != null && project.quotationId != null
              ? String(group.quotationId) === String(project.quotationId)
              : (group._key === key)
          );
          const matchingLead = leads.find((lead) =>
            lead.quotationId != null && project.quotationId != null
              ? String(lead.quotationId) === String(project.quotationId)
              : lead.ProjectName === project.ProjectName
          );

          if (existingGroup) {
            existingGroup.Projects.push(project);
          } else {
            acc.push({
              _key: key,
              quotationId: project.quotationId || null,
              isRead: matchingLead?.isRead || false,
              AssignedGroup: project.AssignedGroup,
              groupid: project.groupid,
              ProjectName: project.ProjectName,
              DateRequested: project.DateRequested,
              ProjectDueDate: project.ProjectDueDate,
              Projects: [project],
            });
          }
          return acc;
        },
        []
      );

      setOngoingSalesProject(groupedProjects);
    }
  }, [projects, leads]);


  useEffect(() => {
    if (projects?.length) {
      const projectsWithQualifiedPersons = projects.filter((project) =>
        project?.Assignedperson?.some(
          (person) => person.salespersonstatus === "project complete"
        )
      );

      const projectKey = (p) => p.quotationId ? String(p.quotationId).trim() : `${p.ProjectName || ''}||${p.ClientName || ''}||${p.AssignedGroup || ''}`.toLowerCase().trim();
      const groupedProjects = projectsWithQualifiedPersons.reduce(
        (acc, project) => {
          const key = projectKey(project);
          const existingGroup = acc.find((group) =>
            group.quotationId != null && project.quotationId != null
              ? String(group.quotationId) === String(project.quotationId)
              : (group._key === key)
          );
          const matchingLead = leads.find((lead) =>
            lead.quotationId != null && project.quotationId != null
              ? String(lead.quotationId) === String(project.quotationId)
              : lead.ProjectName === project.ProjectName
          );

          if (existingGroup) {
            existingGroup.Projects.push(project);
          } else {
            acc.push({
              _key: key,
              quotationId: project.quotationId || null,
              isRead: matchingLead?.isRead || false,
              AssignedGroup: project.AssignedGroup,
              groupid: project.groupid,
              ProjectName: project.ProjectName,
              DateRequested: project.DateRequested,
              ProjectDueDate: project.ProjectDueDate,
              Projects: [project],
            });
          }
          return acc;
        },
        []
      );

      setSalesCompletedGroupProject(groupedProjects);
    }
  }, [projects, leads]);


  const requestOutstandingRef = useRef(null);
  const responseReceivedRef = useRef(null);
  const projectApprovedRef = useRef(null);
  const projectAssignRef = useRef(null);
  const projectOngoingRef = useRef(null);
  const projectCompletedRef = useRef(null);

  const refsMap = {
    projectRequestOutstanding: requestOutstandingRef,
    projectReceived: responseReceivedRef,
    projectApproved: projectApprovedRef,
    projectAssign: projectAssignRef,
    projectOngoing: projectOngoingRef,
    projectCompleted: projectCompletedRef,
  };

  // one function to handle tab change + scroll
  const handleTabClick = (tabKey) => {
    // setSelectedTab(tabKey);
    setTimeout(() => {
      refsMap[tabKey]?.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100); // slight delay so component mounts first
  };



  const [ongoingProjectssalesPerson, setongoingProjectssalesPerson] = useState([]);
  const LoggedUser = localStorage.getItem("email");

  useEffect(() => {
    const filtered = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some(
          (person) => person.managerstatus === "project ongoing"
        )
    );
    const managerProjects = filtered.filter((proj) =>
      proj.SalesPersonEmail === LoggedUser
    );
    setongoingProjectssalesPerson(managerProjects);
  }, [projects, LoggedUser]);

  useEffect(() => {
    if (projectTrackingWorkEntries?.length && ongoingSalesProject?.length) {
      // Get all project IDs from ongoingSalesProject by flattening the Projects arrays
      const ongoingProjectIds = ongoingSalesProject.flatMap(project =>
        project.Projects?.map(nestedProject => nestedProject._id) || []
      );

      const filtered = projectTrackingWorkEntries.filter((entry) => {
        const matchesProject = ongoingProjectIds.includes(entry.projectid);
        return matchesProject;
      });
      const hardwareParts = hardwareProjectTracking.filter((entry) => {
        const matchesProject = ongoingProjectIds.includes(entry.projectid);
        return matchesProject;
      });

      setongoingEntries(filtered);
      setongoingHardwareParts(hardwareParts)
    } else {
      // Clear ongoingEntries if conditions aren't met
      setongoingEntries([]);
    }
  }, [projectTrackingWorkEntries, employees, ongoingProjectssalesPerson, ongoingSalesProject, hardwareProjectTracking]);

  const hasNoFeatureConfig =
    !currentEmployee?.featureAccess || currentEmployee.featureAccess.length === 0;
  const resolvedAuthLevel = String(
    currentEmployee?.EmpAuthLevel ??
    session?.auth ??
    (typeof localStorage !== "undefined" ? localStorage.getItem("auth") : "")
  )
    .trim()
    .toUpperCase();
  const isL0Admin =
    resolvedAuthLevel === "L0";
  const isSalesPersonL3 = resolvedAuthLevel === "L3";
  const shouldShowOutstandingHoverInfo = isSalesPersonL3 && isErpPackage;

  const requestBucketHoverTextMap = {
    outstanding:
      "Project Name - Assign Task to Managers (Selection of Primary Manager - Optional) - Forward to all Managers - Cancel (If required) - Reassign to Managers",
    responseReceived:
      "Project Name - View Details - Accept/Reject/Cancel",
    projectApproved:
      "Project Name - View Details - Assign Task to Managers (Reassign to same manager) or (Assign to new managers) - Cancel the project",
    projectAssigned:
      "Project Name - View Details - Accept/Reject Project",
    projectOngoing:
      "Project Name - View Details - Approved Final Complete",
    projectCompleted:
      "Project Name - View Details",
  };
  const canShowProjectTracker = hasNoFeatureConfig || hasViewOrFullAccess(currentEmployee, "MY REQUEST");
  const canShowTaskInHand =
    isL0Admin || hasViewOrFullAccess(currentEmployee, "TASK IN HAND");
  const canShowUtilizationReport = hasNoFeatureConfig || hasViewOrFullAccess(currentEmployee, "UTILISATION REPORT");
  // Admin (L0) cannot create / assign / delete trainings, so hide the My Trainings section entirely.
  const canShowMyTrainings = !isL0Admin && (hasNoFeatureConfig || hasViewOrFullAccess(currentEmployee, "MY TRAININGS"));
  const canShowOperationsTrackerHeading =
    canShowProjectTracker || canShowTaskInHand || canShowUtilizationReport || canShowMyTrainings;

  const myRequestAccessLevel = getFeatureAccessLevel(currentEmployee, "MY REQUEST");
  const isViewOnlyMyRequests = !hasNoFeatureConfig && myRequestAccessLevel &&
    String(myRequestAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  const taskInHandAccessLevel = getFeatureAccessLevel(currentEmployee, "TASK IN HAND");
  const isViewOnlyTaskInHand =
    !isL0Admin &&
    !hasNoFeatureConfig &&
    taskInHandAccessLevel &&
    String(taskInHandAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  const utilizationAccessLevel = getFeatureAccessLevel(currentEmployee, "UTILISATION REPORT");
  const isViewOnlyUtilization = !hasNoFeatureConfig && utilizationAccessLevel &&
    String(utilizationAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  console.log("Access Level - MY REQUEST:", myRequestAccessLevel, "isViewOnly:", isViewOnlyMyRequests);
  console.log("Access Level - TASK IN HAND:", taskInHandAccessLevel, "isViewOnly:", isViewOnlyTaskInHand);
  console.log("Access Level - UTILISATION REPORT:", utilizationAccessLevel, "isViewOnly:", isViewOnlyUtilization);
  // Fixed width per panel so "My Requests" stays in place when other panels are hidden
  // My Requests: 40%, Ongoing Tasks In Hand: 35%, Utilization Report: 35%
  const myRequestsWidth = "w-[40%]";
  const taskInHandWidth = "w-[35%]";
  const utilizationReportWidth = "w-[35%]";

  return (
    <>
      {/* Always show Operations Tracker Dashboard for sales / presales users
          who reach this component. Higher‑level routing already controls
          which roles can see SalesProjects. */}
      <div className="pt-2">
        <div className="">

          {canShowOperationsTrackerHeading && (
            <div className="bg-white p-2 flex justify-between align-middle items-center rounded-md ">
              <h1 className="text-xl font-semibold">
                Operations Tracker Dashboard
              </h1>
              <div className="relative cursor-pointer bg-transparent"></div>
            </div>
          )}

          {(canShowProjectTracker || canShowTaskInHand || canShowUtilizationReport) && <div className="flex gap-2 pt-2">
            {/* My Requests */}
            {canShowProjectTracker && (
            <div className={`${myRequestsWidth} bg-white rounded-md pl-2 pr-2 pt-3`}>
              <div className=" relative">
                <div className="relative bg-[#E8E8E8] text-black border border-gray-400 text-lg text-center py-2 rounded-t-lg font-semibold">
                  My Requests
                </div>
                <div className="flex w-full h-full pt-5 p-2 gap-2">
                          <div
                            className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px] cp:h-[480px] flex-1 min-w-0 items-center"
                            onMouseEnter={() =>
                              shouldShowOutstandingHoverInfo &&
                              setHoveredRequestBucket("outstanding")
                            }
                            onMouseLeave={() => setHoveredRequestBucket("")}
                          >
                            <div className="w-[20%] flex justify-center">
                              <p className="-rotate-90 text-black text-sm font-semibold whitespace-nowrap">
                                Project Requests Outstanding
                              </p>
                            </div>
                            <div
                              onClick={() =>
                                handleRestrictedBucketClick(
                                  handleprojectRequest,
                                  "Project Requests Outstanding",
                                  true
                                )
                              }
                              className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showOutstanding
                                ? "bg-blue-600 border-[#3a1e0a] shadow-lg"
                                : "bg-[#4e95d9] border-[#5A3D2B]"
                                }`}
                              style={{ borderColor: "#5A3D2B" }}
                            >
                              {unreadleadcount.length > 0 && (
                                <div className="absolute top-3 flex justify-center align-middle items-center">
                                  {/* <NotificationsActiveIcon
                                  className="text-black w-6 h-6"
                                /> */}
                                  <span

                                    className=" opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full"
                                  >
                                    {unreadleadcount.length}
                                  </span>
                                </div>
                              )}

                              <span className="text-white text-xl font-semibold">
                                {requestedprojectsNew.length}
                              </span>
                              {showOutstanding && (
                                <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                              )}
                            </div>
                          </div>

                          <div
                            className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px] cp:h-[480px] flex-1 min-w-0 items-center"
                            onMouseEnter={() =>
                              shouldShowOutstandingHoverInfo &&
                              setHoveredRequestBucket("responseReceived")
                            }
                            onMouseLeave={() => setHoveredRequestBucket("")}
                          >
                            <div className="w-[20%] flex justify-center">
                              <p className="-rotate-90 text-black text-sm font-semibold whitespace-nowrap">
                                Response Received
                              </p>
                            </div>

                            <div
                              onClick={() =>
                                handleRestrictedBucketClick(
                                  handleProjectReceivedList,
                                  "Response Received"
                                )
                              }
                              className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showRR
                                ? "bg-blue-600 border-[#3a1e0a] shadow-lg"
                                : "bg-[#83cbeb] border-[#5A3D2B]"
                                }`}
                              style={{ borderColor: "#5A3D2B" }}
                            >
                              {/* 🔔 UNREAD ICON */}
                              {!isCrmPackage && unreadleadcountRR.length > 0 && (
                                <div className="absolute top-3 unreadleadcountRRicon flex justify-center align-middle items-center">
                                  {/* <NotificationsActiveIcon className="text-black w-6 h-6" /> */}
                                  <span className=" bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                                    {unreadleadcountRR.length}
                                  </span>
                                </div>
                              )}

                                <span className="text-white text-xl font-semibold">
                                {isCrmPackage ? "🔒" : projectsReceived.length}
                              </span>

                              {showRR && (
                                <ExpandMoreIcon className="absolute bottom-3 text-white cursor-pointer" />
                              )}
                            </div>

                          </div>

                          <div
                            className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px] cp:h-[480px] flex-1 min-w-0 items-center"
                            onMouseEnter={() =>
                              shouldShowOutstandingHoverInfo &&
                              setHoveredRequestBucket("projectApproved")
                            }
                            onMouseLeave={() => setHoveredRequestBucket("")}
                          >
                            <div className="w-[20%] flex justify-center">
                              <p className="-rotate-90 text-black text-sm font-semibold whitespace-nowrap">
                                Project Approved
                              </p>
                            </div>

                            <div
                              onClick={() =>
                                handleRestrictedBucketClick(
                                  handleProjectApproved,
                                  "Project Approved"
                                )
                              }
                              className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showaproved
                                ? "bg-yellow-600 border-[#3a1e0a] shadow-lg"
                                : "bg-[#ffc000] border-[#5A3D2B]"
                                }`}
                              style={{ borderColor: "#5A3D2B" }}
                            >
                              {!isCrmPackage && unreadleadcountapproved.length > 0 && (
                                <div className="absolute top-3 unreadleadcountRRicon flex justify-center align-middle items-center">
                                  {/* <NotificationsActiveIcon className="text-black w-6 h-6" /> */}
                                  <span className=" bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                                    {unreadleadcountapproved.length}
                                  </span>
                                </div>
                              )}
                              <span className="text-white text-xl font-semibold">
                                {isCrmPackage ? "🔒" : mergedapprovedData.length}
                              </span>
                              {showaproved && (
                                <ExpandMoreIcon className="absolute bottom-2 text-white cursor-pointer" />
                              )}
                            </div>
                          </div>

                          <div
                            className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px] cp:h-[480px] flex-1 min-w-0 items-center"
                            onMouseEnter={() =>
                              shouldShowOutstandingHoverInfo &&
                              setHoveredRequestBucket("projectAssigned")
                            }
                            onMouseLeave={() => setHoveredRequestBucket("")}
                          >
                            <div className="w-[20%] flex justify-center">
                              <p className="-rotate-90 text-black text-sm font-semibold whitespace-nowrap">
                                Project Assigned
                              </p>
                            </div>

                            <div
                              onClick={() =>
                                handleRestrictedBucketClick(
                                  handleProjectAssignList,
                                  "Project Assigned"
                                )
                              }
                              className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showassign
                                ? "bg-yellow-800 border-[#3a1e0a] shadow-lg"
                                : "bg-[#cfb053] border-[#5A3D2B]"
                                }`}
                              style={{ borderColor: "#5A3D2B" }}
                            >
                              {!isCrmPackage && unreadleadcountassign.length > 0 && (
                                <div className="absolute top-3 unreadleadcountRRicon flex justify-center align-middle items-center">
                                  {/* <NotificationsActiveIcon className="text-black w-6 h-6" /> */}
                                  <span className=" bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                                    {unreadleadcountassign.length}
                                  </span>
                                </div>
                              )}
                              <span className="text-white text-xl font-semibold">
                                {isCrmPackage ? "🔒" : salesAssignedGroupProject.length}
                              </span>
                              {showassign && (
                                <ExpandMoreIcon className="absolute bottom-2 text-white cursor-pointer" />
                              )}
                            </div>
                          </div>

                          <div
                            className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px] cp:h-[480px] flex-1 min-w-0 items-center"
                            onMouseEnter={() =>
                              shouldShowOutstandingHoverInfo &&
                              setHoveredRequestBucket("projectOngoing")
                            }
                            onMouseLeave={() => setHoveredRequestBucket("")}
                          >
                            <div className="w-[20%] flex justify-center">
                              <p className="-rotate-90 text-black text-sm font-semibold whitespace-nowrap">
                                Project Ongoing
                              </p>
                            </div>

                            <div
                              onClick={() =>
                                handleRestrictedBucketClick(
                                  handleprojectOngoing,
                                  "Project Ongoing"
                                )
                              }
                              className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showongoing
                                ? "bg-[#D27D2D] border-[#3a1e0a] shadow-lg"
                                : "bg-yellow-700 border-[#5A3D2B]"
                                }`}
                              style={{ borderColor: "#5A3D2B" }}
                            >
                              {!isCrmPackage && unreadleadcountongoing.length > 0 && (
                                <div className="absolute top-3 unreadleadcountRRicon flex justify-center align-middle items-center">
                                  {/* <NotificationsActiveIcon className="text-black w-6 h-6" /> */}
                                  <span className=" bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                                    {unreadleadcountongoing.length}
                                  </span>
                                </div>
                              )}
                              <span className="text-white text-xl font-semibold">
                                {isCrmPackage ? "🔒" : ongoingSalesProject.length}
                              </span>
                              {showongoing && (
                                <ExpandMoreIcon className="absolute bottom-2 text-white cursor-pointer" />
                              )}
                            </div>
                          </div>

                          <div
                            className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px] cp:h-[480px] flex-1 min-w-0 items-center"
                            onMouseEnter={() =>
                              shouldShowOutstandingHoverInfo &&
                              setHoveredRequestBucket("projectCompleted")
                            }
                            onMouseLeave={() => setHoveredRequestBucket("")}
                          >
                            <div className="w-[20%] flex justify-center">
                              <p className="-rotate-90 text-black text-sm font-semibold whitespace-nowrap">
                                Project Completed
                              </p>
                            </div>

                            <div
                              onClick={() =>
                                handleRestrictedBucketClick(
                                  handleprojectCompleted,
                                  "Project Completed"
                                )
                              }
                              className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showcomplete
                                ? "bg-green-600 border-[#3a1e0a] shadow-lg"
                                : "bg-[#47d45a] border-[#5A3D2B]"
                                }`}
                              style={{ borderColor: "#5A3D2B" }}
                            >
                              {!isCrmPackage && unreadleadcountcomplete.length > 0 && (
                                <div className="absolute top-3 unreadleadcountRRicon flex justify-center align-middle items-center">
                                  {/* <NotificationsActiveIcon className="text-black w-6 h-6" /> */}
                                  <span className=" bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                                    {unreadleadcountcomplete.length}
                                  </span>
                                </div>
                              )}
                              <span className="text-white text-xl font-semibold">
                                {isCrmPackage ? "🔒" : salesCompletedGroupProject.length}
                              </span>
                              {showcomplete && (
                                <ExpandMoreIcon className="absolute bottom-2 text-white cursor-pointer" />
                              )}
                            </div>
                          </div>
                </div>
                {shouldShowOutstandingHoverInfo && hoveredRequestBucket && (
                  <div className="mx-2 mb-2 border border-gray-500 bg-[#f2f2f2] px-3 py-2 text-center text-[15px] font-medium text-black rounded-sm">
                    {requestBucketHoverTextMap[hoveredRequestBucket]}
                  </div>
                )}
              </div>
            </div>
            )}

            {/* Task In Hand */}
            {canShowTaskInHand && (
            <div className={`${taskInHandWidth} bg-white rounded-md`}>
              <TaskInHand
                ongoingHardwareParts1={ongoingHardwareParts}
                ongoingEntries1={ongoingEntries}
                ongoingOpProjectsState1={ongoingSalesProject}
                isInteractionDisabled={isCrmPackage || isViewOnlyTaskInHand}
                onInteractionDisabled={isCrmPackage ? showUpgradePopupForErp : undefined}
                isViewOnly={isViewOnlyTaskInHand}
              />
            </div>
            )}

            {/* Utilisation Report */}
            {canShowUtilizationReport && (
            <div className={`${utilizationReportWidth} `}>
              <UtilizationReport
                ongoingProjectsManager1={ongoingSalesProject}
                ongoingEntries1={ongoingEntries}
                User={"Sales"}
                isInteractionDisabled={isCrmPackage || isViewOnlyUtilization}
                onInteractionDisabled={isCrmPackage ? showUpgradePopupForErp : undefined}
                isViewOnly={isViewOnlyUtilization}
              />
            </div>
            )}
          </div>}
        </div>

        {canShowProjectTracker && showOutstanding && (
              <div ref={requestOutstandingRef}>
                <SalesPresalesOperations
                  handlerefresh={handlerefresh}
                  dispatch={dispatch}
                  fetchAllProjects={fetchAllProjects}
                  Setrequestedprojects={Setrequestedprojects}
                  requestedprojects={requestedprojectsNew}
                  groupedProjects={groupedProjects}
                  entries={entries}
                  tasks={tasks}
                  items={items}
                  employees={employees}
                  isViewOnly={isViewOnlyMyRequests}
                />
              </div>
        )}

        {canShowProjectTracker && showRR && (
              <div ref={responseReceivedRef}>
                <ResponseReceived
                  handlerefresh={handlerefresh}
                  projectsReceived={projectsReceived}
                  dispatch={dispatch}
                  fetchAllProjects={fetchAllProjects}
                  entries={entries}
                  tasks={tasks}
                  items={items}
                  employees={employees}
                  isViewOnly={isViewOnlyMyRequests}
                />
              </div>
        )}

        {canShowProjectTracker && showaproved && (
              <div ref={projectApprovedRef}>
                {/* <ProjectApprovedSales
            dispatch={dispatch}
            fetchAllProjects={fetchAllProjects}
            projectsApprovedSales={projectsApprovedSales}
            entries={entries}
            tasks={tasks}
            items={items}
            employees={employees}
          /> */}
                <ApprovedSales
                  projectsApprovedSales={projectsApprovedSales}
                  handlerefresh={handlerefresh}
                  isViewOnly={isViewOnlyMyRequests}
                />
              </div>
        )}

        {canShowProjectTracker && showassign && (
              <div ref={projectAssignRef}>
                <ProjectAssignSales
                  handlerefresh={handlerefresh}
                  dispatch={dispatch}
                  fetchAllProjects={fetchAllProjects}
                  salesAssignedGroupProject={salesAssignedGroupProject}
                  projectTrackingWorkEntries={projectTrackingWorkEntries}
                  hardwareProjectTracking={hardwareProjectTracking}
                  descriptionProjectTracking={descriptionProjectTracking}
                  entries={entries}
                  tasks={tasks}
                  items={items}
                  employees={employees}
                  isViewOnly={isViewOnlyMyRequests}
                />
              </div>
        )}

        {canShowProjectTracker && showongoing && (
              <div ref={projectOngoingRef}>
                <ProjectOngoingSales
                  fetchAllProjects={fetchAllProjects}
                  dispatch={dispatch}
                  ongoingSalesProject={ongoingSalesProject}
                  projectTrackingWorkEntries={projectTrackingWorkEntries}
                  hardwareProjectTracking={hardwareProjectTracking}
                  descriptionProjectTracking={descriptionProjectTracking}
                  entries={entries}
                  tasks={tasks}
                  items={items}
                  employees={employees}
                  handlerefresh={handlerefresh}
                  isViewOnly={isViewOnlyMyRequests}
                />
              </div>
        )}

        {canShowProjectTracker && showcomplete && (
              <div ref={projectCompletedRef}>
                <ProjectCompletedSales
                  projectTrackingWorkEntries={projectTrackingWorkEntries}
                  hardwareProjectTracking={hardwareProjectTracking}
                  descriptionProjectTracking={descriptionProjectTracking}
                  salesCompletedGroupProject={salesCompletedGroupProject}
                  entries={entries}
                  tasks={tasks}
                  items={items}
                  employees={employees}
                  handlerefresh={handlerefresh}
                  leads={leads}
                  isViewOnly={isViewOnlyMyRequests}
                />
              </div>
            )}
      </div>

      {/* {currentEmployee?.featureAccess?.includes("MY TRAININGS") && ( */}
      {canShowMyTrainings && (
          <div className="flex gap-2 pt-2" >
            <div className="border-gray-400 w-[100%] overflow-x-auto">
              <div className="w-full">
                <MyTraining projects={projects} />
              </div>
            </div>
          </div>
        )}


    </>
  );
};

export default SalesProjects;
